import React, { useEffect, useLayoutEffect } from "react";

/** Components */
import { TablePagination, Paper, TableContainer, Table, TableHead, TableBody, TableCell, TableRow, TableFooter } from "@mui/material";
import LoadingProgress from "../../commons/LoadingProgress.component";
/** Icons */

/** Api & Function */
import { getAppId } from "./../../../services/api";
import { setHeaderTitle } from "../../../store/layoutSlide";
import { convertQueryStringToObject } from "../../../services/libService";

/** Package */
import moment from "moment";

/** Hook */

import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useParamFilter } from "../../commons/customHook";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";

export default function AppId() {
  const [t] = useTranslation();
  // custom hook
  const location = useLocation();
  const dispatch = useDispatch();

  const { fetchData, data, page, perPage, setPage, setPerPage, total, isAllow, loading } = useParamFilter({ page: 1, per_page: 50 }, getAppId);

  // effect
  useLayoutEffect(() => {
    fetchData(convertQueryStringToObject(location.search));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    dispatch(setHeaderTitle("THÔNG TIN ỨNG DỤNG DI ĐỘNG"));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      {/* <div style={{ justifyContent: 'end', display: 'flex', backgroundColor: '#b3deff', marginBottom: 20, height: 50}}>
                <ButtonGroup >
                    <Button onClick={() => setSearchOpen(prev => !prev)} variant="outlined">
                        <SearchIcon />
                    </Button>
                    <ButtonWithAPICall title='Đồng bộ dữ liệu' api={() => postSync({ object: 'po' })} variant='outlined' >
                        <RefreshIcon />
                    </ButtonWithAPICall>
                </ButtonGroup>
            </div> */}
      <div>
        {/* <Collapse in={isSearchOpen}>
                    <FilterBy style={{ display: 'inline-flex', margin: '5px', minWidth: 240 }}
                        getDataFunc={() => getCustomers({ status: 1 })}
                        value={input.selectedCustomer || null}
                        onChange={(e, newValue) => setInput(prev => ({ ...prev, selectedCustomer: newValue }))}
                        label={t('Nhà cung cấp')}
                        setDefaultFunc={(option) => setInput(prev => ({ ...prev, selectedCustomer: option.find(item => item.id == filter.provider_id) }))}
                        triggerSetDefaultFunc={true}
                        setDefaultDependencies={[filter.customer_id]}
                    />
                    <FilterBy style={{ display: 'inline-flex', margin: '5px', minWidth: 240 }}
                        getDataFunc={() => getLoadingType({ status: 1 })}
                        value={input.loadingtype || null}
                        onChange={(e, newValue) => setInput(prev => ({ ...prev, loadingtype: newValue }))}
                        label={t('Kiểu vận chuyển')}
                        setDefaultFunc={(option) => setInput(prev => ({ ...prev, loadingtype: option.find(item => item.id == filter.loadingtype_id) }))}
                        triggerSetDefaultFunc={true}
                        setDefaultDependencies={[filter.loadingtype_id]}
                    />
                    <Button variant='outlined' onClick={handleSearch} style={{ margin: '10px 0' }}>{t('Tìm kiếm')}</Button>
                </Collapse> */}
        <div align="right" style={{ marginBottom: 10, marginTop: 10, backgroundColor: "#b3deff", height: 40 }}></div>
        <div style={{ display: "flex" }}>
          {loading ? (
            <LoadingProgress />
          ) : (
            <TableContainer component={Paper} style={{ width: "98%", marginLeft: 10 }} sx={{ maxHeight: 800 }}>
              <Table stickyHeader>
                <TableHead style={{ backgroundColor: "#f0f3f5" }}>
                  <TableRow>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      STT
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Mã ứng dụng")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Chi nhánh")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Tên người đăng nhập")}
                    </TableCell>
                    <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                      {t("Ngày đăng nhập lần đầu")}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {data.length ? (
                    data.map((item, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.id}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.appid}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.organization}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="left">
                          {item.username}
                        </TableCell>
                        <TableCell style={{ border: "0.5px solid lightgray" }} align="center">
                          {item.created_at && moment(item.created_at).format("DD/MM/YYYY")}
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell align="center" colSpan={20}>
                        {t(isAllow ? "Không có dữ liệu" : "No permission")}
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
                <TableFooter>
                  <TableRow>
                    <TablePagination rowsPerPageOptions={[50, 100, 150]} count={total || 0} rowsPerPage={perPage} page={page} onPageChange={setPage} onRowsPerPageChange={setPerPage} />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )}
        </div>
      </div>
    </div>
  );
}
